/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-console */
const LIB = "@9amhealth/shared";

export function log(message: string, ...args: any[]): void {
  const fs = args.length ? 14 : 12;
  console.log(
    `%c${message}${args.length ? ":" : ""}`,
    `color:rgb(3, 242, 255); font-family: monospace; font-size: ${fs}px; font-weight: bold`
  );
  if (args.length) {
    console.log(...args);
    let dashes = Array(Math.min(message.length - 3, 40))
      .fill("-")
      .join("");
    // place END in the middle of the dashes
    const endIndex = Math.floor(dashes.length / 2);
    dashes = dashes.slice(0, endIndex) + "END" + dashes.slice(endIndex);

    console.log(
      `%c${dashes}`,
      `color:rgb(3, 186, 196); font-family: monospace; font-size: ${fs}px; font-weight: bold`
    );
  }
}

export function warn(message: string, ...args: any[]): void {
  if (args.length) console.warn("DETAILS:\n", ...args);
  console.warn(
    `%c${LIB}
%c██╗    ██╗ █████╗ ██████╗ ███╗   ██╗
██║    ██║██╔══██╗██╔══██╗████╗  ██║
██║ █╗ ██║███████║██████╔╝██╔██╗ ██║
██║███╗██║██╔══██║██╔══██╗██║╚██╗██║
╚███╔███╔╝██║  ██║██║  ██║██║ ╚████║
 ╚══╝╚══╝ ╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═══╝
%c
${message}${args.length > 0 ? "\n- See details in previous log message." : ""}
`,
    "color: #000; color: #fff",
    "color: #879623; font-family: monospace; font-size: 10px; font-weight: bold",
    undefined
  );
}

export function error(message: string, ...args: any[]): void {
  if (args.length) console.error("DETAILS:\n", ...args);
  console.error(
    `%c${LIB}
%c███████╗██████╗ ██████╗  ██████╗ ██████╗
██╔════╝██╔══██╗██╔══██╗██╔═══██╗██╔══██╗
█████╗  ██████╔╝██████╔╝██║   ██║██████╔╝
██╔══╝  ██╔══██╗██╔══██╗██║   ██║██╔══██╗
███████╗██║  ██║██║  ██║╚██████╔╝██║  ██║
╚══════╝╚═╝  ╚═╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝
%c
${message}${args.length > 0 ? "\n- See details in previous log message." : ""}

`,
    "color: #000; color: #fff",
    "color: #ff9623; font-family: monospace; font-size: 10px; font-weight: bold",
    undefined
  );
}
